import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { PopupIconIDs } from '../../../core/feedback.service';
import { LinebreakPipe } from '../../../pipes/linebreak.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

interface ErrorPopupData {
  actionPerformed: string;
  messages: string[];
}

export enum PopupPanelClasses {
  SUCCESS = 'success-popup',
  INFO = 'info-popup',
  WARNING = 'warning-popup',
  ALERT = 'alert-popup'
}

@Component({
    selector: 'app-custom-popup',
    templateUrl: './custom-popup.component.html',
    styleUrls: ['./custom-popup.component.scss'],
    standalone: true,
    imports: [
        MatIcon,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule,
        LinebreakPipe,
    ],
})
export class CustomPopupComponent implements OnInit {

  // used in template
  panelClasses = PopupPanelClasses;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorPopupData,
              private dialogRef: MatDialogRef<CustomPopupComponent>,
              private clipboard: Clipboard,
  ) {
  }

  ngOnInit(): void {
    this.data.messages = this.data.messages.filter(
        msg => msg && msg.trim().length > 0,
    );
  }

  /**
   * Generates the return result from the dialog to the parent component, which indicates the parent to apply the
   * UpdateError-Filter for the address list.
   */
  generateResult() {
    return {
      selection: 'fireNextAction',
    };
  }

  /**
   * Creates a string out of error messages (comma-delimited) and copies it to clipboard
   */
  copyToClipboard() {
    this.clipboard.copy(this.data?.messages?.join(', '));
  }

  getLeftIcon(): string {
    if (this.isOfPanelClass(PopupPanelClasses.INFO)) {
      return PopupIconIDs.INFO;
    }
    if (this.isOfPanelClass(PopupPanelClasses.SUCCESS)) {
      return PopupIconIDs.SUCCESS;
    }
    if (this.isOfPanelClass(PopupPanelClasses.ALERT)) {
      return PopupIconIDs.ALERT;
    }
    if (this.isOfPanelClass(PopupPanelClasses.WARNING)) {
      return PopupIconIDs.WARNING;
    }
    return null;
  }

  isOfPanelClass(panelClass: PopupPanelClasses): boolean {
    const panelClasses: string | string[] = this.dialogRef._containerInstance._config.panelClass;
    if (typeof panelClasses === 'string') {
      return panelClasses === panelClass;
    } else {
      return panelClasses.indexOf(panelClass) !== -1;
    }
  }
}
